<template>
  <div class = "paginaDedicata">
    <NormalHeader :data="header"/>
    <img :src="logo" class = "imagine">
    <h1 class = "title">{{$t(title)}}</h1>
    <p v-html="$t(text1)" class = "text"></p>
    <img :src="img1" class = "imagine">
    <img :src="img2" class = "imagine">
    <h2 class = "subtitle">{{$t(subtitle)}}</h2>
    <p v-html="$t(text2)" class = "tex"></p>
    <ol>
      <li v-html="$t(number1)"></li>
        <ul>
          <li v-html="$t(bullet1)"></li>
          <li v-html="$t(bullet2)"></li>
          <ul>
            <li v-html="$t(bullet3)"></li>
            <li v-html="$t(bullet4)"></li>
          </ul> 
        </ul>
      <li v-html="$t(number2)"></li>
      <li v-html="$t(number3)"></li>
    </ol>  
    <p v-html="$t(text3)" class = "text"></p>
  </div>  
</template>

<script>
import NormalHeader from '@/components/global-components/NormalHeader'
export default {
  components:{
    NormalHeader
  },
  data() {
    return {
      header: {
        transparent: false
      },
      logo: "https://i.imgur.com/pS6sLVQ.png",
      img1: "https://i.imgur.com/XsGO0BH.png",
      img2: "https://i.imgur.com/L1OdKpk.png",
      title: "dedicate.enevo.title",
      subtitle: "dedicate.enevo.subtitle",
      text1: "dedicate.enevo.text1",
      text2: "dedicate.enevo.text2",
      text3: "dedicate.enevo.text3",
      bullet1: "dedicate.enevo.bullet1",
      bullet2: "dedicate.enevo.bullet2",
      bullet3: "dedicate.enevo.bullet3",
      bullet4: "dedicate.enevo.bullet4",
      number1: "dedicate.enevo.number1",
      number2: "dedicate.enevo.number2",
      number3: "dedicate.enevo.number3",
      header: {
        transparent: false
      }
    }
  }
} 
</script>

<style scoped lang="scss">
.imagine {
  margin-top: 2%!important;
  margin-bottom: 2%!important;
  padding-top: 0px;
  display: block;
  margin: auto;
  max-width: 80%;
}
.poza {
  display: block;
  margin: auto;
  margin-top: 3%!important;
  margin-bottom: 3%!important;
  max-height: 40vh;
}

.title {
  margin-bottom: 3%;
  font-size: 35px!important;
}

.text {
  text-align: center;
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 2%;
  margin-top: 2%;
  font-size: 20px!important;
}

.tex {
  text-align: left;
  font-size: 20px!important;
  margin-left: 4%;
  margin-right: 4%;
}

.subtitle {
   font-size: 30px!important;
}

.paginaDedicata {
  color: $primary-color !important;
  margin-bottom: 30px;
}
ul { 
  display: block;
  list-style-type: disc;
  color: black;
  margin-left: 10%;
  margin-right: 10%;
}
li{
  text-align: left;
  margin-bottom: 3px!important;
  font-size: 20px!important;
  margin-left: 2%;
  margin-right: 2%;
  list-style-position: inside;
}
ol {
  color: black;
  margin-top: 0px;
}

a{
  text-align: center;
  color: black;
  font-size: 20px!important;
  display: block;
  margin-bottom: 5px;
}

@media screen and (max-width: 600px) {
  .imagine {
    height: 9vh;
  }
  .subtitle {
   margin-top: 7%!important;
  }
  .title {
    margin-top: 7%!important;
  }
}

</style>